// extracted by mini-css-extract-plugin
export var footer = "style-module--footer--f49fc";
export var footer__copy = "style-module--footer__copy--27b83";
export var footer__credits = "style-module--footer__credits--f87ab";
export var footer__flex = "style-module--footer__flex--dccf8";
export var footer__inner = "style-module--footer__inner--a547b";
export var footer__logo = "style-module--footer__logo--a0d7b";
export var footer__privacy = "style-module--footer__privacy--42c76";
export var footer__privacyPolicy = "style-module--footer__privacy-policy--0b05c";
export var footer__privacySettings = "style-module--footer__privacy-settings--3288b";